import { InstructorProfileData, ProfileReview } from '../server/types';

// Instructor state data class
class InstructorStateData {
	reviews: ProfileReview[]
	reviewsLoaded: boolean

	profileData: InstructorProfileData | undefined
	profileDataLoaded: boolean

	constructor() {
		this.reviews = []
		this.reviewsLoaded = false
		this.profileDataLoaded = false
		this.profileData = undefined
	}

	public setProfileData(profileData: InstructorProfileData) {
		this.profileData = profileData
	}

	/**
	 * Method to add review to existing array of values
	 * @param reviews array of reviews from the server response
	 */
	public addReviews(reviews: ProfileReview[]) {
		this.reviews = [...this.reviews, ...reviews]
	}

	/**
	 * Method for clearing the current reviews to make way for new search results
	 */
	public clearExistingReviews(): void {
		// TODO: create method which will filter existing profiles with new profile list to allow for smoother clearing of results
		this.reviews = []
	}
}

export const instructorStateData: InstructorStateData = new InstructorStateData()